





































import 'vue-awesome/icons/grip-lines'

export default
  name: 'account_category_edit'
  data: ->
    return {
      positions: []
      form: null
    }
  computed:
    edited: -> @$store.state.ui.account_categories.edited
    accounts_length: ->  @edited.children().length
  watch:
    edited: ->
      @form = _.clone(@$store.state.ui.account_categories.edited)
      if @form?.id
        @$nextTick => $(@$el).find("[name='name']").focus()
        requestIdleCallback =>
          component = @
          $table = $(@$el).find('#positions tbody')[0]
          return unless $table
          @sortable = new Sortable $table,
            group: 'account_categories'
            sort: true
            delay: (if @HM.is_touch then 100 else 0)
            draggable: 'tr'
            onSort: (evt) -> component.positions = @toArray()
      else
        requestIdleCallback =>
          @sortable.destroy() if @sortable
          @sortable = null
  methods:
    close: -> @$store.commit 'ACCOUNT_CATEGORIES/EDIT', null
    submitForm: ->
      @$store.dispatch 'saveAccountCategory',
        account_category: @form
        positions: @positions
      HM.track("account_category-save")
      @close()
      @$message.success @$t('Done')
    destroy: (form) ->
      if @accounts_length > 0
        alert(@$t("accounts_present"))
        return
      @$store.dispatch 'destroyAccountCategory', @form
      HM.track("account_category-destroy")
      @$message.success @$t('Done')
      @close()
